// Shared hardening for the campaign builder's rendered-email preview. Pure
// string helper — no React, no IO.

// The previews render inside `sandbox=""` iframes, which already blocks
// scripts, forms and top-level navigation. It does NOT block the iframe from
// navigating ITSELF, so a click on the email's unsubscribe link would fire a
// real opt-out request. This CSP additionally blocks scripts, frames and
// fetch/XHR so rendered email HTML cannot phone home from the builder. Inline styles
// stay allowed — email HTML is styled inline.
//
// `img-src` MUST allow https: — the logo and any merchant artwork are real CDN
// URLs (the store's Pantry brand logo, asset-library images), and a data:-only
// policy renders them as broken-image icons even though the field holds a valid
// URL. Images are inert content in a script-less sandboxed iframe, and the real
// mail client loads them anyway, so this matches what the recipient will see.
const PREVIEW_CSP_META =
  '<meta http-equiv="Content-Security-Policy" content="default-src \'none\'; style-src \'unsafe-inline\'; img-src data: https:;">'

// Makes every link/interactive target inert WITHOUT changing how the email
// looks: same text, same styling, just no navigation. Injected on every render
// so it survives the HTML being rebuilt when field values change.
const PREVIEW_INERT_STYLE =
  '<style>a,area,form,button,input,select,textarea{pointer-events:none!important;cursor:default!important;}</style>'

const PREVIEW_HEAD = `${PREVIEW_CSP_META}${PREVIEW_INERT_STYLE}`

// Wraps server-rendered email HTML for safe display in a sandboxed preview
// iframe. Use this for the `srcDoc` of the builder's Live Preview.
export const buildPreviewSrcDoc = (html: string): string =>
  /<head[^>]*>/i.test(html)
    ? html.replace(/<head[^>]*>/i, (match) => `${match}${PREVIEW_HEAD}`)
    : `${PREVIEW_HEAD}${html}`
